import { combineReducers } from '@reduxjs/toolkit';
import appReducer from './app/appSlice';
import { apiReducer } from './apiDefinitions';
import { apiDetailReducer } from './apiDetails';
import { articlesReducer } from './articles';

export const rootReducer = combineReducers({
  app: appReducer,
  api: apiReducer,
  apiDetail: apiDetailReducer,
  articles: articlesReducer,
});
